import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY,
  FETCH_USER_ORDER_TRANSACTION_HISTORY,
  SEARCH_ORDER_TRANSACTION_BY_ID,
} from '../actions/order_transaction_history/action_types';
import actions from '../actions/order_transaction_history';
import rf from '../../requests/RequestFactory';

// saga effect

function* fetchFilterOrderTransaction(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('OrderTransactionHistoryRequest').fetchFilterOrderTransactionHistory(params), action.params);
    yield put(actions.fetchFilterTransactionHistoryActionSucced(data, totalCount));
    if (isFunction(action.callback)) {
      yield action.callback(totalCount);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchFilterTransactionHistoryActionFailed(err));
  }
}

function* fetchUserOrderTransHistory(action) {
  try {
    const { data, total_count } = yield call((params) => rf.getRequest('OrderTransactionHistoryRequest').fetchUserOrderTransHistory(params), action.params);
    console.log('data', data);
    if (isFunction(action.callback)) {
      yield action.callback(total_count);
    }
    yield put(actions.fetchUserOrderTransHistoryActionSucceed(data, total_count));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchUserOrderTransHistoryActionFailed(err));
  }
}

function* searchOrderTransByID(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderTransactionHistoryRequest').searchByOrderTrans(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(data);
    }

    // yield put(actions.fetchUserOrderTransHistoryActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.searchOrderTransByIDActionFailed(err));
  }
}

function* watchOrderTransactionHistory() {
  yield takeLatest(FETCH_FILTER_ORDER_TRANSACTION_HISTORY, fetchFilterOrderTransaction);
  yield takeLatest(FETCH_USER_ORDER_TRANSACTION_HISTORY, fetchUserOrderTransHistory);
  yield takeLatest(SEARCH_ORDER_TRANSACTION_BY_ID, searchOrderTransByID);
}

export default function* rootSaga() {
  yield all([fork(watchOrderTransactionHistory)]);
}
